/** 登录后的页面刷新必须等待提醒关闭，避免提示随登录弹窗一起消失。 */
export async function showInitialPasswordNotice(vm, loginData, english = false) {
  if (!loginData || loginData.must_change_password !== true) return;
  try {
    await vm.$alert(
      english
        ? 'Please change your temporary password in My Account > Change Password.'
        : '请初次登陆后在我的-密码修改中修改密码。',
      english ? 'Update Your Password' : '初始密码修改提醒',
      {
        confirmButtonText: english ? 'Got It' : '我知道了',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false
      }
    );
  } catch (error) { /* 提醒被关闭不改变已经成功的登录结果。 */ }
}
